import React from 'react';

function TermsOfUse() {
  return (
    <div style={{
      maxWidth: '800px',
      margin: '0 auto',
      padding: '2rem',
      backgroundColor: '#ffffff',
      borderRadius: '12px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
    }}>
      <h1 style={{ 
        fontSize: '2.5rem', 
        marginBottom: '2rem', 
        color: '#212529',
        textAlign: 'center'
      }}>Terms of Use</h1>
      
      <div style={{ color: '#212529', lineHeight: '1.6' }}>
        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#1e40af' }}>1. Introduction</h2>
          <p>Welcome to Pre Go Prep. By accessing and using our website and services, you agree to comply with and be bound by these Terms of Use.</p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#1e40af' }}>2. Services Overview</h2>
          <p>Pre Go Prep provides a platform for:</p>
          <ul style={{ marginLeft: '2rem', marginTop: '1rem' }}>
            <li>Calculating estimated performance times</li>
            <li>Managing therapeutic application schedules</li>
            <li>Organizing race information</li>
            <li>Storing horse and rider data</li>
          </ul>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#1e40af' }}>3. User Accounts</h2>
          <p>When creating an account, you agree to:</p>
          <ul style={{ marginLeft: '2rem', marginTop: '1rem' }}>
            <li>Provide accurate and complete information</li>
            <li>Maintain the security of your account credentials</li>
            <li>Notify us immediately of any unauthorized access</li>
            <li>Take responsibility for all activities under your account</li>
          </ul>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#1e40af' }}>4. User Responsibilities</h2>
          <p>As a user of Pre Go Prep, you agree to:</p>
          <ul style={{ marginLeft: '2rem', marginTop: '1rem' }}>
            <li>Use the service for its intended purpose</li>
            <li>Verify all calculations with official event schedules</li>
            <li>Comply with all applicable laws and regulations</li>
            <li>Respect the rights of other users</li>
          </ul>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#1e40af' }}>5. Prohibited Activities</h2>
          <p>Users must not:</p>
          <ul style={{ marginLeft: '2rem', marginTop: '1rem' }}>
            <li>Attempt to bypass any security measures</li>
            <li>Use the service for unauthorized commercial purposes</li>
            <li>Share account access with unauthorized users</li>
            <li>Upload malicious content or code</li>
          </ul>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#1e40af' }}>6. Intellectual Property</h2>
          <p>All content, features, and functionality of Pre Go Prep are owned by us and protected by international copyright, trademark, and other intellectual property laws.</p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#1e40af' }}>7. Disclaimer of Warranties</h2>
          <p>Pre Go Prep services are provided "as is" without any warranties, express or implied. We do not guarantee the accuracy of calculations or the availability of services.</p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#1e40af' }}>8. Limitation of Liability</h2>
          <p>Pre Go Prep shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use or inability to use the service.</p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#1e40af' }}>9. Changes to Terms</h2>
          <p>We reserve the right to modify these terms at any time. Continued use of the service after changes constitutes acceptance of the modified terms.</p>
        </section>

        <div style={{ 
          marginTop: '3rem', 
          padding: '1rem', 
          backgroundColor: '#f8fafc', 
          borderRadius: '8px',
          textAlign: 'center'
        }}>
          <p style={{ marginBottom: '1rem' }}>
            By using Pre Go Prep, you acknowledge that you have read and agreed to these Terms of Use.
          </p>
          <p style={{ color: '#64748b' }}>
            Last Updated: March 25, 2025
          </p>
        </div>
      </div>
    </div>
  );
}

export default TermsOfUse; 